import TSX from "./Numbering";

export default TSX;
